import { removeWhiteSpaceFromObjectKeys } from 'common/utilities/utils';

/**
 * Maps localization data for an address.
 * @param {object} param0 - An object containing localization data and address details.
 * @param {Array} param0.localizationData - object containing localization data.
 * @param {object} param0.address - Address details including chome, cityTown, postalCode, and prefecture.
 * @returns {object} - Mapped localization data with formatted address details.
 */
export const mapLocalizationData = ({ localizationData = {}, address = {} }) => {
  const { chome = '', cityTown = '', postalCode = '', prefecture = '' } = address;

  return {
    chome: chome?.replace(/\s+/g, ''),
    cityTown,
    localizationData,
    postalCode: postalCode?.replace('-', ''),
    prefecture: prefecture?.replace(/\s+/g, ''),
  };
};

/**
 * Get store details from stores aggregated by prefectures
 * @param {*} - An object containing chome, cityTown, localizationData, postalCode, and prefecture.
 * @returns {string} - The store information corresponding to the chome.
 */
export const getStoreFromPrefectures = ({ chome = '', cityTown = '', localizationData = {}, prefecture = '' }) => {
  const { [prefecture]: { [cityTown]: chomesObj } = {} } = localizationData;
  const cleanChomesObj = removeWhiteSpaceFromObjectKeys(chomesObj) || {};

  return cleanChomesObj[chome];
};

/**
 * Get store details from stores aggregated by postal codes
 * @param {*} - An object containing chome, cityTown, localizationData, postalCode, and prefecture.
 * @returns {string} - The store information corresponding to the chome.
 */
export const getStoreFromPostalCodes = ({ chome = '', localizationData = {}, postalCode = '' }) => {
  const { [postalCode]: chomesObj = {} } = localizationData;
  const cleanChomesObj = removeWhiteSpaceFromObjectKeys(chomesObj);

  return cleanChomesObj[chome];
};
